import {
  useTheme,
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  Button,
  Typography,
  IconButton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Emoji from '../../../static/Emojiscaraspensando.b7378fcab21a.svg';
import Points from '../../../theme/assets/hackupoints.svg?react';
import ClosePurpleIcon from '../../../static/closePurpleIcon.svg';
import { useUser } from '@/components/AuthInterceptorComponent/hooks/useUser';

type ErrorModalProps = {
  open: boolean;
  onClose: () => void;
  answers?: Record<any, any>[];
  tryAgain: () => void;
  customFeedback?: string | null;
};

export function ErrorModal({
  open,
  onClose,
  answers,
  tryAgain,
  customFeedback,
}: ErrorModalProps) {
  const theme = useTheme();
  const { user } = useUser();
  const { t } = useTranslation();

  const RenderFeedBack = () => {
    if (Boolean(customFeedback)) {
      return <>{customFeedback}</>;
    }
    return (
      <>
        {t('selfAssesmentPage.youChooseAnswer')}
        <b> {t('selfAssesmentPage.wrong')}</b>
      </>
    );
  };

  return (
    <Box>
      <Dialog
        open={open}
        onClose={() => onClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: '1rem',
            paddingY: '2.5rem',
            width: '100%',
            height: 'auto',
            overflow: 'hidden',
            backgroundImage: `url(${Emoji})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%',
          },
        }}
      >
        <>
          <IconButton
            aria-label="close"
            onClick={() => onClose()}
            sx={{
              position: 'absolute',
              right: '0rem',
              top: '0rem',
            }}
          >
            <img src={ClosePurpleIcon} alt="close" width="35" />
          </IconButton>
          <DialogContent
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              paddingTop: '5rem',
            }}
          >
            <Box
              textAlign={'center'}
              alignSelf={'flex-end'}
              width={'100%'}
              paddingTop="1rem"
            >
              <Box>
                <Box
                  width={'80px'}
                  height={'80px'}
                  borderRadius={'50%'}
                  position={'relative'}
                  display={'flex'}
                  justifyContent={'center'}
                  alignItems={'center'}
                  ml={'auto'}
                  mr={'auto'}
                  sx={{
                    backgroundColor: theme.palette.error.main,
                    boxShadow: '0px 0px 10px 1px #690727 inset',
                  }}
                >
                  <Typography fontWeight={'bolder'} fontSize={'3.5rem'}>
                    X
                  </Typography>
                </Box>
                <Typography
                  fontWeight={'bolder'}
                  fontFamily={'Gotham Rounded'}
                  fontSize={'20px'}
                >
                  {user?.first_name},
                </Typography>
                <Typography fontSize={'1rem'} fontFamily={'Gotham Rounded'}>
                  <RenderFeedBack />
                </Typography>
                <Typography fontSize={'1rem'} fontFamily={'Gotham Rounded'}>
                  {t('selfAssesmentPage.doesntMatter')}
                </Typography>
              </Box>
              <Box mt={'2rem'}>
                {answers?.map((answer, index) => (
                  <Box key={index + 'answer'}>
                    <Typography
                      fontFamily={'Gotham Rounded'}
                      fontSize={'0.9rem'}
                      fontWeight={'bold'}
                    >
                      Pregunta {answer.questionIndex}
                    </Typography>
                    <Box
                      borderRadius={'25px'}
                      width={'70%'}
                      sx={{
                        backgroundColor: answer?.isCorrect
                          ? theme.palette.success.main
                          : theme.palette.error.main,
                      }}
                      height={'3rem'}
                      display={'flex'}
                      ml={'auto'}
                      mr={'auto'}
                      mb={'1rem'}
                      justifyContent={'center'}
                      alignItems={'center'}
                    >
                      <Typography fontFamily={'Gotham Rounded'}>
                        Elegiste la opcion {answer?.option}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: 'center',
              padding: '20px 24px',
              display: 'flex',
              flexDirection: 'column',
              alignSelf: 'flex-start',
              margin: '-2rem',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '-0.6rem',
              }}
            >
              <Points
                style={{
                  width: '25px',
                }}
              />{' '}
              <Typography fontWeight={'bold'} fontFamily={'Gotham Rounded'}>
                + 0
              </Typography>
            </Box>
            <Button
              sx={{
                color: theme.palette.common.white,
                width: '60%',
                borderRadius: '50px',
                background:
                  'radial-gradient(120.73% 120.73% at 50% 6.1%, #391F58 44.79%, #572E88 83.85%)',
                fontFamily: 'Gotham Rounded',
                textTransform: 'none',
              }}
              onClick={tryAgain}
              variant="contained"
            >
              {t('selfAssesmentPage.tryAgain')}
            </Button>
          </DialogActions>
        </>
      </Dialog>
    </Box>
  );
}
